module.exports = __webpack_public_path__ + "img/stock12.ea8431fd.png";